import React from 'react';
import { StyleSheet } from 'react-native';
import { Tappable, TappableProps } from 'src/components/Tappable/Tappable';

export type CellButtonProps = TappableProps;

export const CellButton: React.FC<CellButtonProps> = ({ children, style, ...props }) => (
  <Tappable style={[s.root, style]} hoverable {...props}>
    {children}
  </Tappable>
);

const s = StyleSheet.create({
  root: {
    minHeight: 48,
    width: 48,
    marginRight: -12,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
